module.exports = __webpack_public_path__ + "img/24.5ff2769c.jpg";